export default __webpack_public_path__ + "static/media/icaew_background_m2.60213505.jpg";